export default __webpack_public_path__ + "static/media/rocket.0e8f0698.svg";